// Responsive original bottle photography (Nov 2026 owner photos, shot on black).
// `src` is the seeded /images/products/<slug>-800.jpg; 480w webp derived by convention.
export const BottleImg = ({ src, alt, className, pictureClassName = "", loading = "lazy", sizes = "(max-width: 640px) 60vw, 320px", width = 300, height = 400 }) => {
  const base = src.replace(/\.(jpg|png)$/, ".webp");
  const w480 = base.replace("-800.webp", "-480.webp");
  return (
    <picture className={pictureClassName}>
      <source srcSet={`${w480} 480w, ${base} 800w`} sizes={sizes} type="image/webp" />
      <img src={src} alt={alt} width={width} height={height} loading={loading} className={className} />
    </picture>
  );
};
